
import { useEffect, useRef, useState } from "react";

import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { Avatar, Box, Button, Card, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, Tab, Tabs, Typography } from "@mui/material";

import { DocumentEditorContainerComponent, CustomToolbarItemModel, ToolbarItem, Toolbar } from "@syncfusion/ej2-react-documenteditor";
import { DropDownButton, ItemModel } from "@syncfusion/ej2-react-splitbuttons";
import moment from "moment";

import { TabPanel, TabProps } from "../../../helpers/TabPanel";
import { DefaultDocumentEditor } from "../../../helpers/DefaultDocumentEditor";

import { openSnackbar } from "../../../store/slices/SnackbarSlice";

import { DialogActionsStyle, DialogContentStyle } from "../../../styles/DialogStyle";

import { Layout } from "../../../components/Layout"
import { BoxProcesoTerminado } from "../../../components/BoxProcesoTerminado";
import { BoxProcesoCancelado } from "../../../components/BoxProcesoCancelado";
import { BoxHeaderInformacion } from "../../../components/BoxHeaderInformacion";
import { BoxProcesoNoEncontrado } from "../../../components/BoxProcesoNoEncontrado";
import { BoxInformacionExpediente } from "../../../components/BoxInformacionExpediente";
import { CircularProgressIndicator } from "../../../components/CircularProgressIndicator";
import { BoxInformacionExhortoRecibido } from "../../../components/BoxInformacionExhortoRecibido";

import { ObtenerClaseExhorto } from "../../../connections/catalogos/ClaseExhortoConnection";
import { ObtenerObjetoExhorto } from "../../../connections/catalogos/ObjetoExhortoConnection"
import { ObtenerDistritoJudicial } from "../../../connections/catalogos/DistritoJudicialConnection";
import { ObtenerPlantilla, ObtenerPlantillaDetalle } from '../../../connections/admin/PlantillaConnection';
import { ActualizarEstatus, DetalleExhortoLibrado, GuardarExhortoLibrado } from "../../../connections/tribunal/ExhortoLibradoConnection";

import { ClaseExhortoProps } from '../../../interfaces/catalogos/ClaseExhortoInterface';
import { ObjetoExhortoProps } from '../../../interfaces/catalogos/ObjetoExhortoInterface'
import { DistritoJudicialProps } from "../../../interfaces/catalogos/DistritoJudicialInterface";
import { PlantillaProps, ObtenerPlantillasParams } from '../../../interfaces/admin/PlantillaInterface';
import { defaultExhortoLibrado, ExhortoLibradoProps, GuardarExhortoLibradoParams } from "../../../interfaces/tribunal/ExhortoLibradoInterface";

DocumentEditorContainerComponent.Inject(Toolbar);

const defaultDocument = DefaultDocumentEditor();

interface ItemModelModif extends ItemModel {
    value?: string;
}

export const ElaborarExhortoLibradoPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const navigate = useNavigate();

    const syncfusionEditor = useRef<DocumentEditorContainerComponent | null>( null );
    const contenidoRef = useRef( '' );

    const dropCampos = useRef<DropDownButton>( null );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [value, setValue] = useState( 0 );

    const [editorReady, setEditorReady] = useState( false );

    const [loading, setLoading] = useState( true );
    const [loadingGuardar, setLoadingGuardar] = useState( false );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [objetoExhorto, setObjetoExhorto] = useState( 0 );
    const [objetoExhortoArray, setObjetoExhortoArray] = useState<ObjetoExhortoProps[]>( [] );

    const [claseExhorto, setClaseExhorto] = useState( 0 );
    const [claseExhortoArray, setClaseExhortoArray] = useState<ClaseExhortoProps[]>( [] );

    const [distritoJudicial, setDistritoJudicial] = useState( 0 );
    const [distritoJudicialArray, setDistritoJudicialArray] = useState<DistritoJudicialProps[]>( [] );

    const [plantilla, setPlantilla] = useState( 0 );
    const [plantillaArray, setPlantillaArray] = useState<PlantillaProps[]>( [] );

    const [exhortoLibrado, setExhortoLibrado] = useState<ExhortoLibradoProps>( defaultExhortoLibrado );

    const [dirigidoJuzgadoEstado, setDirigidoJuzgadoEstado] = useState( true );

    let Toolbar: (CustomToolbarItemModel | ToolbarItem)[] = [
        'New',
        'Open',
        'Separator',
        'Undo',
        'Redo',
        'Separator',
        'Image',
        'Table',
        'Separator',
        'Header',
        'Footer',
        'Separator',
        {
            tooltipText: 'Atajos',
            text: 'Atajos',
            id: 'dropItem',
            prefixIcon: "e-icons e-drop-down",
        }
    ];

    // ------------------------------------------------------------------------------------------------------------------------

    const validateFields = () => {

        let valid = true;

        if ( objetoExhorto === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el objeto del exhorto', variant: 'warning' }));
            valid = false;

        }

        if ( claseExhorto === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar la clase del exhorto', variant: 'warning' }));
            valid = false;

        }

        if ( dirigidoJuzgadoEstado && distritoJudicial === 0 ) {

            dispatch( openSnackbar({ message: 'Debes seleccionar el distrito judicial', variant: 'warning' }));
            valid = false;

        }

        return valid;
    }

    const handleChange = (_: React.SyntheticEvent, newValue: number) => {

        if ( value === 0 && newValue !== 0 ) {

            const serialized = syncfusionEditor.current?.documentEditor.serialize() ?? '';

            contenidoRef.current = serialized;
            setEditorReady( false );
        }

        setValue( newValue );
    }

    const Guardar = async () => {

        const params: GuardarExhortoLibradoParams = {
            idExhortoLibrado: Id ?? '',
            idPlantilla: plantilla,
            contenido: syncfusionEditor?.current?.documentEditor.serialize() ?? '',
            idDistritoJudicial: !dirigidoJuzgadoEstado ? 0 : distritoJudicial,
            idObjetoExhorto: objetoExhorto,
            idClaseExhorto: claseExhorto,
            dirigidoJuzgadoEstado: dirigidoJuzgadoEstado
        }

        return await GuardarExhortoLibrado( params );
    }

    const handleGuardar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingGuardar( true );

        await Guardar().then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    dispatch(openSnackbar({ message: message, variant: 'success' }));
                    setLoadingGuardar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingGuardar( false );

                }

            }, 700);

        });

    }

    const handleFinalizar = async () => {

        const validate = validateFields();

        if ( !validate ) return;

        setLoadingFinalizar( true );

        const { success: successGuardar, message: messageGuardar } = await Guardar();

        if (!successGuardar) {

            setTimeout(() => {

                dispatch(openSnackbar({ message: messageGuardar, variant: 'error' }));
                setLoadingFinalizar( false );

            }, 700);

            return;
        }

        await ActualizarEstatus({ idExhortoLibrado: Id ?? '', idEstatus: 47, observacion: '', }).then(resp => {

            setTimeout(() => {

                const { success, message, nombreUsuarioAsignado, asignadoMismoUsuario } = resp;

                if ( success ) {

                    if ( asignadoMismoUsuario ) {

                        navigate(`/tribunal/exhorto-librado/autorizar/${ Id ?? '' }`);

                    } else {

                        setProcesoTerminado( true );
                        setMensajeAsignacion(`La siguiente actividad se asignó a ${ nombreUsuarioAsignado }`);

                    }

                    setLoadingFinalizar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    const handleChangePlantilla = async ( value: number ) => {

        setPlantilla( value );

        await ObtenerPlantillaDetalle( value ).then( resp => {

            const { idPlantilla, contenido, } = resp;

            if ( idPlantilla !== 0 ) {

                if (!(/<\/?[a-z][\s\S]*>/.test( contenido ))) {

                    const contentSetValues = reemplaceData( contenido );

                    syncfusionEditor.current?.documentEditor.open( contentSetValues );

                }
                else if (/<\/?[a-z][\s\S]*>/.test( contenido )) {

                    const contenidoParser = contenido.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').replace(/&/g, "").replace(/acute;/g, "") ?? "";

                    const contentSetValues = reemplaceData( contenidoParser );

                    syncfusionEditor.current?.documentEditor.open( defaultDocument );

                    syncfusionEditor.current?.documentEditor.editor.insertText( contentSetValues );
                }
                else {
                    syncfusionEditor.current?.documentEditor.open( defaultDocument );
                }

            }

        });

    }

    const reemplaceData = ( contenido: string ) => {

        const { numeroExhorto, juez, expediente, exhortoRecibido } = exhortoLibrado;

        let contentSetValues = contenido
            .replaceAll('[Numero_Oficio]', numeroExhorto)
            .replaceAll('[Juez]', juez);

        if ( expediente.idExpediente !== 0 ) {

            const actores = expediente.actores.join(', ');
            const demandados = expediente.demandados.join(', ');

            contentSetValues = contentSetValues
                .replaceAll('[Numero_Expediente]', expediente.numeroExpediente)
                .replaceAll('[Numero_Folio]', expediente.numeroFolio)
                .replaceAll('[Tipo_juicio]', expediente.tipoJuicio)
                .replaceAll('[Juez_Expediente]', expediente.juez)
                .replaceAll('[Juzgado_Origen]', expediente.juzgadoOrigen)
                .replaceAll('[Secretario_Tramite]', expediente.secretarioTramite)
                .replaceAll('[Secretario_Ejecucion]', expediente.secretarioEjecucion)
                .replaceAll('[Secretario_TramiteMenor]', expediente.secretarioTramiteMenor)
                .replaceAll('[Actores]', actores)
                .replaceAll('[Demandados]', demandados)
                .replaceAll('[Fecha_Expediente]', expediente.fecha ? moment( expediente.fecha ).format('DD-MM-YYYY') : '' );

        }

        if ( exhortoRecibido.idExhortoRecibido !== 0 ) {

            const actores = exhortoRecibido.actores.join(', ');
            const demandados = exhortoRecibido.demandados.join(', ');

            contentSetValues = contentSetValues
                .replaceAll('[Numero_Exhorto]', exhortoRecibido.numeroExhorto)
                .replaceAll('[Numero_Expediente]', exhortoRecibido.numeroExpedienteOrigen)
                .replaceAll('[Numero_Folio]', exhortoRecibido.numeroFolio)
                .replaceAll('[Folio_Buzon]', exhortoRecibido.folioBuzonElectronico)
                .replaceAll('[Tipo_juicio]', exhortoRecibido.tipoJuicio)
                .replaceAll('[Juez_Exhorto]', exhortoRecibido.juez)
                .replaceAll('[Juzgado_Origen]', exhortoRecibido.juzgadoOrigen)
                .replaceAll('[Autoridad_Exhorto]', exhortoRecibido.autoridadExhortoRecibido)
                .replaceAll('[Secretario_Tramite]', exhortoRecibido.secretario)
                .replaceAll('[Actores]', actores)
                .replaceAll('[Demandados]', demandados)
                .replaceAll('[Fecha_Exhorto]', exhortoRecibido.fecha ? moment( exhortoRecibido.fecha ).format('DD-MM-YYYY') : '' );

        }

        return contentSetValues;
    }
    //--------------------------------------------- funciones para el editor de text --------------------------------------------------

    const handleEditorCreated = () => {
        setEditorReady( true );
    };

    useEffect(() => {

        if ( value === 0 && !loading && editorReady && syncfusionEditor.current ) {

            syncfusionEditor.current.documentEditor.open( contenidoRef.current || DefaultDocumentEditor() );
            syncfusionEditor.current.documentEditorSettings.showRuler = true;
            syncfusionEditor.current.documentEditor.pageOutline = '#D0D0D0';

            dropCampos.current?.appendTo('#dropItem');

        }

    }, [ value, loading, editorReady ]);

    //----------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        async function Obtener() {

            await ObtenerDistritoJudicial().then( resp => {
                setDistritoJudicialArray( resp );
            })

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerObjetoExhorto().then( resp => {
                setObjetoExhortoArray( resp );
            })

        }

        Obtener();

    }, [])

    useEffect(() => {

        async function Obtener() {

            await ObtenerClaseExhorto().then( resp => {
                setClaseExhortoArray( resp );
            })

        }

        Obtener();

    }, [])

    useEffect(() => {

        setPlantilla( 0 );
        setPlantillaArray( [] );

        async function Obtener() {

            const params: ObtenerPlantillasParams = {
                idTipoAcuerdo: 15,
                idSubTipoAcuerdo: 0,
                idTipoNotificacion: 0,
                idAutoridad: 0,
            };

            await ObtenerPlantilla( params ).then( resp => {
                setPlantillaArray( resp );
            })

        }

        Obtener();

    }, [])

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleExhortoLibrado( Id ?? ' ').then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setExhortoLibrado( resp );

                        contenidoRef.current = resp.contenido;

                        setPlantilla( resp.idPlantilla );
                        setClaseExhorto( resp.idClaseExhorto );
                        setDistritoJudicial( resp.idDistritoJudicial );
                        setObjetoExhorto( resp.idObjetoExhorto );
                        setDirigidoJuzgadoEstado( resp.dirigidoJuzgadoEstado );

                        const mkItem = (text: string, id: string, value: string): ItemModelModif[] =>
                            [{ text, id, iconCss: 'e-icons e-bookmark', value }, { separator: true }];

                        const joinNames = (arr: string[]) => arr.join(', ');

                        const fmtDate = (d: any) => moment(d).format('DD-MM-YYYY');

                        let items: ItemModelModif[] = [
                            ...mkItem('Fecha Actual', '1', '[Fecha_Actual]'),
                            ...mkItem('Numero de exhorto librado', '2', resp.numeroExhorto),
                        ];

                        if ( resp.idExpediente !== 0 ) {

                            const { expediente: e } = resp;

                            items.push(
                                ...mkItem('Número de Expediente', '4', e.numeroExpediente),
                                ...mkItem('Tipo de Juicio', '6', e.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', e.juzgadoOrigen),
                                ...mkItem('Fecha del Expediente', '11', fmtDate(e.fecha)),
                                ...mkItem('Actor(es)', '12', joinNames( e.actores )),
                                ...mkItem('Demandado(s)', '13', joinNames( e.demandados )),
                                ...mkItem('Juez', '13', e.juez),
                            );

                            if ( e.numeroFolio ) items.push(...mkItem('Número de Folio', '14', e.numeroFolio));
                            if ( e.secretario ) items.push(...mkItem('Secretario(a) de admisibilidad', '16', e.secretario));
                            if ( e.secretarioTramite ) items.push(...mkItem('Secretario(a) de Tramite Mayor', '5', e.secretarioTramite));
                            if ( e.secretarioTramiteMenor ) items.push(...mkItem('Secretario(a) de Tramite Menor', '7', e.secretarioTramiteMenor));
                            if ( e.secretarioEjecucion ) items.push(...mkItem('Secretario(a) de Ejecucion', '15', e.secretarioEjecucion));

                        }

                        if ( resp.idExhortoRecibido !== 0 ) {

                            const { exhortoRecibido: ex } = resp;

                            items.push(
                                ...mkItem('Número de Exhorto', '4', ex.numeroExhorto),
                                ...mkItem('Tipo de Juicio', '6', ex.tipoJuicio),
                                ...mkItem('Juzgado Origen', '10', ex.juzgadoOrigen),
                                ...mkItem('Fecha del Exhorto', '11', fmtDate(ex.fecha)),
                                ...mkItem('Actor(es)', '12', joinNames( ex.actores )),
                                ...mkItem('Demandado(s)', '13', joinNames( ex.demandados )),
                                ...mkItem('Juez', '13', ex.juez),
                                ...mkItem('Autoridad del Exhorto', '13', ex.autoridadExhortoRecibido),
                            );

                            if ( ex.numeroFolio ) items.push(...mkItem('Número de Folio', '14', ex.numeroFolio));
                            if ( ex.secretario ) items.push(...mkItem('Secretario(a)', '5', ex.secretario));
                            if ( ex.numeroExpedienteOrigen ) items.push(...mkItem('Número de Expediente Origen', '7', ex.numeroExpedienteOrigen));
                        }

                        if ( items[items.length - 1]?.separator ) { items.pop(); }

                        dropCampos.current = new DropDownButton({
                            items: items,
                            beforeItemRender: (data: ItemModelModif) => {
                                return `<div>
                                            <span class="e-menu-icon ${data.iconCss}"></span>
                                            <span class="custom-class" >${data.text}</span>
                                        </div>`;
                            },
                            select: (args) => syncfusionEditor.current?.documentEditor.editor.insertText(args?.item.value ?? ""),
                        },);

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${resp.nombreUsuarioAsignado}`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 46 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 46 ) {
                            setLoading( false );
                        }

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        Obtener();

    }, [ Id ])

    return (
        <Layout breadcrumbs={ [{ text: 'Tribunal' }, { text: 'Exhorto librado' }, { text: 'Elaborar exhorto librado' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ exhortoLibrado.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange } aria-label="basic tabs example">

                                        <Tab label="Exhorto librado" {...TabProps( 0 )} />

                                        <Tab
                                            label="Información del expediente"
                                            sx={{ display: exhortoLibrado.idExpediente !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(1)}
                                        />

                                        <Tab
                                            label="Información del exhorto"
                                            sx={{ display: exhortoLibrado.idExhortoRecibido !== 0 ? 'flex' : 'none' }}
                                            {...TabProps(25)}
                                        />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box sx={{ display: value === 0 ? 'block' : 'none' }}>

                                        <Box p={ 4 } component={ Paper }>

                                            <BoxHeaderInformacion
                                                numeroSeguimiento={ `GEXL-${ exhortoLibrado.idExhortoLibrado }` }
                                                fecha={ exhortoLibrado.fecha ?? new Date() }
                                                juez={ exhortoLibrado.juez }
                                                numeroExhorto={ exhortoLibrado.numeroExhorto }
                                            />

                                            <Grid container spacing={ 3 } mt={ 3 }>

                                                <Grid size={{ md: dirigidoJuzgadoEstado ? 6 : 12, xs: 12 }}>

                                                    <FormControl>

                                                        <FormLabel>¿El exhorto librado se dirige a un juzgado perteneciente al Poder Judicial del Estado?</FormLabel>
                                                        <RadioGroup row>

                                                            <FormControlLabel
                                                                label="Si"
                                                                control={
                                                                    <Radio
                                                                        checked={ dirigidoJuzgadoEstado }
                                                                        onChange={ () => setDirigidoJuzgadoEstado( true ) }
                                                                    />
                                                                }
                                                            />

                                                            <FormControlLabel
                                                                label="No"
                                                                control={
                                                                    <Radio
                                                                        checked={ !dirigidoJuzgadoEstado }
                                                                        onChange={ () => setDirigidoJuzgadoEstado( false ) }
                                                                    />
                                                                }
                                                            />

                                                        </RadioGroup>

                                                    </FormControl>

                                                </Grid>

                                                {
                                                    dirigidoJuzgadoEstado
                                                    &&
                                                        <Grid size={{ md: 6, xs: 12 }}>

                                                            <FormControl fullWidth>
                                                                <InputLabel>Distrito judicial</InputLabel>

                                                                <Select
                                                                    label="Distrito judicial"
                                                                    value={ distritoJudicial }
                                                                    onChange={ (e) => setDistritoJudicial( e.target.value ) }
                                                                >
                                                                    <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                                    {
                                                                        distritoJudicialArray
                                                                        .map(({ idDistritoJudicial, descripcion }) => (
                                                                            <MenuItem key={ idDistritoJudicial } value={ idDistritoJudicial }>{descripcion}</MenuItem>
                                                                        ))
                                                                    }
                                                                </Select>

                                                            </FormControl>

                                                        </Grid>
                                                }

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl fullWidth>
                                                        <InputLabel>Objeto del exhorto</InputLabel>

                                                        <Select
                                                            label="Objeto del exhorto"
                                                            value={ objetoExhorto }
                                                            onChange={ (e) => setObjetoExhorto( e.target.value ) }
                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                objetoExhortoArray
                                                                .map(({ idObjetoExhorto, descripcion }) => (
                                                                    <MenuItem key={ idObjetoExhorto } value={ idObjetoExhorto }>{descripcion}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>

                                                    </FormControl>

                                                </Grid>

                                                <Grid size={{ md: 6, xs: 12 }}>

                                                    <FormControl fullWidth>
                                                        <InputLabel>Clase del exhorto</InputLabel>

                                                        <Select
                                                            label="Clase del exhorto"
                                                            value={ claseExhorto }
                                                            onChange={ (e) => setClaseExhorto( e.target.value ) }
                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                claseExhortoArray
                                                                .filter(({ idClaseExhorto }) => {
                                                                    return idClaseExhorto === 1;
                                                                })
                                                                .map(({ idClaseExhorto, descripcion }) => (
                                                                    <MenuItem key={ idClaseExhorto } value={ idClaseExhorto }>{descripcion}</MenuItem>
                                                                ))
                                                            }
                                                        </Select>

                                                    </FormControl>

                                                </Grid>

                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <FormControl fullWidth>
                                                        <InputLabel>Plantilla</InputLabel>

                                                        <Select
                                                            label="Plantilla"
                                                            value={ plantilla }
                                                            onChange={ (e) => handleChangePlantilla( e.target.value ) }

                                                        >
                                                            <MenuItem key={ 0 } value={ 0 }>Selecciona una opción</MenuItem>
                                                            {
                                                                plantillaArray.map(({ idPlantilla, descripcion }) => (
                                                                    <MenuItem key={ idPlantilla } value={ idPlantilla }>{descripcion}</MenuItem>
                                                                ))
                                                            }

                                                        </Select>
                                                    </FormControl>

                                                </Grid>

                                                <Grid size={{ md: 12, xs: 12 }}>

                                                    <DocumentEditorContainerComponent
                                                        key='DocumentEditorContainer'
                                                        serviceUrl={ process.env.REACT_APP_URL_SERVICE_DOCUMENT_EDITOR ?? '' }
                                                        height='650'
                                                        ref={ syncfusionEditor }
                                                        enableToolbar={ true }
                                                        showPropertiesPane={ false }
                                                        toolbarItems={ Toolbar }
                                                        autoResizeOnVisibilityChange={ false }
                                                        created={ handleEditorCreated }
                                                    >
                                                    </DocumentEditorContainerComponent>

                                                </Grid>

                                                {
                                                    exhortoLibrado.observaciones.length !== 0
                                                    &&
                                                        <Grid size={{ xs: 12, md: 12 }}>

                                                            <Card sx={{ p: 2 }}>

                                                                <Typography variant="h6" sx={{ mb: 2 }}>
                                                                    Observaciones
                                                                </Typography>

                                                                <Stack spacing={ 2 }>

                                                                    {
                                                                        exhortoLibrado.observaciones.map( ( { usuario, puesto, observacion, fecha }, i ) => (

                                                                            <Box key={ i } sx={{ display: "flex", gap: 1.5, alignItems: "flex-start" }}>

                                                                                <Avatar
                                                                                    sx={{
                                                                                        width: 36,
                                                                                        height: 36,
                                                                                        fontSize: 12,
                                                                                        fontWeight: 500,
                                                                                        bgcolor: (theme) => theme.palette.primary.main,
                                                                                        color: 'white',
                                                                                    }}
                                                                                >
                                                                                    { usuario.split(" ").slice(0, 2).map(n => n[0]).join("") }
                                                                                </Avatar>

                                                                                <Box
                                                                                    sx={{
                                                                                        flex: 1,
                                                                                        bgcolor: "action.hover",
                                                                                        border: "0.5px solid",
                                                                                        borderColor: "divider",
                                                                                        borderRadius: "0 15px 15px 15px",
                                                                                        px: 2,
                                                                                        py: 1.25,
                                                                                    }}
                                                                                >
                                                                                    <Typography variant="subtitle2" fontWeight={ 500 }>
                                                                                        { usuario } { puesto ? `(${ puesto })` : '' }
                                                                                    </Typography>

                                                                                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, lineHeight: 1.5 }}>
                                                                                        { observacion }
                                                                                    </Typography>

                                                                                    {
                                                                                        fecha
                                                                                        &&
                                                                                            <Typography variant="caption" color="text.disabled" sx={{ mt: 0.75, display: "block" }}>
                                                                                            {  fecha ? moment( fecha ).format('DD-MM-YYYY hh:mm a') : '' }
                                                                                            </Typography>

                                                                                    }

                                                                                </Box>

                                                                            </Box>

                                                                        ))
                                                                    }

                                                                </Stack>

                                                            </Card>

                                                        </Grid>
                                                }

                                                <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                    <Grid container spacing={ 3 }>

                                                        <Grid size={{ md: 6, xs: 12 }} sx={{ textAlign: 'right' }}>

                                                            <Button
                                                                fullWidth
                                                                color='secondary'
                                                                variant="outlined"
                                                                loading={ loadingGuardar }
                                                                onClick={ handleGuardar }
                                                            >
                                                                Guardar
                                                            </Button>

                                                        </Grid>

                                                        <Grid size={{ md: 6, xs: 12 }} style={{ textAlign: 'left' }}>

                                                            <Button
                                                                fullWidth
                                                                color='primary'
                                                                variant="contained"
                                                                onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                                disabled={
                                                                    claseExhorto === 0 ||
                                                                    objetoExhorto === 0 ||
                                                                    ( dirigidoJuzgadoEstado && distritoJudicial === 0 )
                                                                }
                                                            >
                                                                Finalizar
                                                            </Button>

                                                        </Grid>

                                                    </Grid>

                                                </Grid>

                                            </Grid>

                                        </Box>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <BoxInformacionExpediente
                                        expediente={ exhortoLibrado.expediente }
                                    />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <BoxInformacionExhortoRecibido
                                        exhortoRecibido={ exhortoLibrado.exhortoRecibido }
                                    />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => {} }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la elaboración del exhorto librado?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar( false ) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ handleFinalizar } variant='contained' > Aceptar </Button>
                                    </DialogActions>

                                </Dialog>

                            </>
            }

        </Layout>
    )
}
